import { useEffect, useState } from "react";
import { getAPI } from "services/CRUDServices";

import { isImageFile } from "tools/functions/Methods";
import { PreviewImage } from "../types";


export const useImageLoader = (
  imageIds: string[],
  mode: "single" | "multiple"
) => {
  const [previews, setPreviews] = useState<PreviewImage[]>([]);

  useEffect(() => {
    if (imageIds.length === 0) {
      setPreviews([]);
      return;
    }

    const loadImages = async () => {
      setPreviews(
        imageIds.map((id, idx) => ({
          url: "",
          name: `فایل ${idx + 1}`,
          id,
          type: "image/jpeg",
          isLoading: true,
        }))
      );

      for (let i = 0; i < imageIds.length; i++) {
        try {
          const res = await getAPI(
            `${process.env.REACT_APP_BASE_URL}/storage-api/indexed-objects/${imageIds[i]}/as-file`,
            true,
            undefined,
            "*/*"
          );

          const contentType = res.headers["content-type"] || "application/octet-stream";
          const blob = new Blob([res.data], { type: contentType });

          setPreviews((prev) => {
            const updated = [...prev];
            updated[i] = {
              ...updated[i],
              url: isImageFile(contentType) ? URL.createObjectURL(blob) : "document",
              type: contentType,
              isLoading: false,
            };
            return updated;
          });
        } catch (error) {
          setPreviews((prev) => prev.filter((_, idx) => idx !== i));
        }
      }
    };
    loadImages();
  }, [imageIds.join(","), mode]);

  return previews;
};
